// extracted by mini-css-extract-plugin
export default {"comment-list":"CommentList_comment-list__DEbpV"};